import { gql } from '@apollo/client';

export * from './billing.query.generated';

export const BILLING = gql`
  query billing {
    billing {
      subscriptions {
        plans {
          id
          name
          currencyCode
          period
          periodUnit
          price
          externalName
        }
        billingPeriod
        billingPeriodUnit
        currencyCode
        coupons
        status
        addons {
          name
          price
          currencyCode
          quantity
          unitPrice
          periodUnit
          externalName
        }
        total
      }
      paymentMethod {
        cardLast4
        cardType
        status
        type
      }
      billingAddress {
        ...BillingAddressFragment
      }
      policy {
        applyCoupon
        cancelSubscription
        update
        requestCancellation
        requestExclusiveOffer
      }
    }
  }
`;
